/* unplugin-vue-components disabled */import { render } from "./TopLeftRightLayout.vue?vue&type=template&id=c537d772&scoped=true"
const script = {}

import "./TopLeftRightLayout.vue?vue&type=style&index=0&id=c537d772&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c537d772"]])

export default __exports__